import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatColumnName',
})
export class FormatColumnNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    const formatted = value
      .replace(/_/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2');
    const addDoubleSpace = formatted.length > 10;
    return addDoubleSpace ? formatted.replace(/ /g, '  ') : formatted;
  }
}
